module.exports = __webpack_public_path__ + "static/media/icon-score-scale.1b0a62f5.svg";